import { Typography, Box, Link, Stack } from "@mui/material";
import logo from "../Static/keysight-logo.svg";
import { SSO_RELOGIN_URL } from "../Components/Util/Util";

const SessionExpired = () => {
	return (
		<Box display="flex" justifyContent="center" alignItems="center">
			<Stack spacing={2}>
				<Box ml={-15} component="img" height={"8rem"} mb={15} alt="Keysight Logo" src={logo} />
				<Typography variant="h4" sx={{ fontWeight: "bold" }}>
					Your Session has Expired
				</Typography>
				<Link color={"secondary"} underline={"hover"} variant="h6" sx={{ fontWeight: "bold" }} href={SSO_RELOGIN_URL}>
					Click here to Relogin
				</Link>
			</Stack>
		</Box>
	);
};

export default SessionExpired;
